"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.appendAttachmentFiles = appendAttachmentFiles;
exports.removeAttachmentFile = removeAttachmentFile;
const fractional_indexing_1 = require("./fractional-indexing");
/**
 * The files of an attachment cell with `added` appended behind the files it
 * holds: each added file gets an order key after the greatest key of the cell,
 * so that a cell appended twice keeps its files in the order they came.
 * Order keys are fractional-indexing keys and start with a letter; an older
 * cell whose keys are digits only sorts before every such key.
 */
function appendAttachmentFiles(existing, added) {
    let last = null;
    for (const file of Object.values(existing ?? {})) {
        const order = file.order;
        if (typeof order === 'string' &&
            /^[A-Za-z]/.test(order) &&
            (last === null || order > last))
            last = order;
    }
    const appended = {};
    for (const [id, file] of Object.entries(added)) {
        last = (0, fractional_indexing_1.generateFractionalIndexingKeyBetween)(last, null);
        appended[id] = { ...file, order: last };
    }
    return { ...existing, ...appended };
}
/**
 * The files of an attachment cell without the file `blobId`; null when the
 * cell holds no such file. The file itself stays stored, as the file a
 * replace overwrites does: only the cell stops naming it.
 */
function removeAttachmentFile(current, blobId) {
    if (!current ||
        typeof current !== 'object' ||
        Array.isArray(current) ||
        !Object.prototype.hasOwnProperty.call(current, blobId))
        return null;
    const { [blobId]: _removed, ...kept } = current;
    return kept;
}
